module.exports = __webpack_public_path__ + "static/media/check.d73e847e.svg";